import React from "react";
import { Button, Card, ProgressBar } from "react-bootstrap";
import "./Portfolio.css";
import project2 from "../../images/project-1.png";
import project3 from "../../images/project-2.png";
import project1 from "../../images/project-4.png";
import myimg from "../../img/bg1.png";
import { MdAddIcCall, MdOutgoingMail } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";

const Portfolio = () => {
  return (
    <div className="container-fulid">
      <div className="container my-5">
        <div className="row g-3 mb-5">
          <div className="col-md-6 col-12 ">
            <p className="mb-3 text-center text-lg-start">
              <img
                src={myimg}
                className="img-fluid  w-25 d-lg-block d-md-block d-sm-block d-none  rounded-pill"
                alt=" my images"
              />
            </p>
            <p className="mb-3 text-center text-lg-start d-lg-none d-md-none d-sm-none d-block">
              <img src={myimg} className="img-fluid  w-75  " alt=" my images" />
            </p>
            <a
              target="_blank"
              rel="noopener"
              className="me-lg-5  d-block text-center d-md-none d-sm-none d-lg-none mb-4 mb-lg-0 color-2"
              href="https://call.whatsapp.com/voice/FHoqUtxIfDuR83Un0D9jjw"
            >
              <BsWhatsapp size="24" className="nav-linker   me-2" />
              WhatsApp
            </a>
            <a target="_blank" rel="noopener" href="">
              <span
                className="color-2 d-block text-center d-md-none d-sm-none d-lg-none"
                onClick={() =>
                  (window.location = "mailto:sajeeb.web@gmail.com")
                }
              >
                {" "}
                <MdOutgoingMail size="24" className="nav-linker " />
                Email
              </span>
            </a>{" "}
            <br></br>
            <span className="title fw-bold">MERN Stack Web Developer</span>
            <h2 className="my-name mt-2">
              Hello, I’m <span>SaJeeb</span> Ahmed
            </h2>
            <p className="my-intro">
              I'm very passionate and dedicated to my work and love to learn new
              things every day. I determined to become a FullStack Web Developer
              & Programmer for working as a Professional Freelancer &
              Entrepreneur. I'm working hard to fulfill my dream.I am a
              self-taught web developer with a strong eye for innovative design
              and a keen understanding of techniques geared toward optimum user
              experience. I believe, there's no limit of learning!
            </p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://drive.google.com/file/d/1wqUb4NMZ0gK7yBx-srB5Y7oDyu8nPSWr/view?usp=share_link"
              className="btn btn-outline-dark"
            >
              Download CV
            </a>
            <span className="d-block span d-md-none d-lg-none"></span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/sajeeb-ahmed/"
              className="btn btn-outline-dark ms-lg-5 ms-0  pt-2"
            >
              Linkedin Profile
            </a>
          </div>

          <div className="col-md-6 col-12 mt-lg-5 pt-lg-5 ">
            <Card className="shadow">
              <Card.Body>
                <Card.Title></Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                  <div>
                    <span>
                      <strong>Email:</strong>
                    </span>{" "}
                    <span>sajeeb.web@gmail.com</span>
                  </div>
                </Card.Subtitle>
                <Card.Text>
                  <div className="mb-3">
                    <div className="mb-2">
                      <span>
                        <strong>Mongo:</strong>
                      </span>
                      <ProgressBar animated variant="success" now={70} />
                    </div>
                    <div className="mb-2">
                      <span>
                        <strong>Express:</strong>
                      </span>
                      <ProgressBar animated variant="danger" now={80} />
                    </div>
                    <div className="mb-2">
                      <span>
                        <strong>React:</strong>
                      </span>
                      <ProgressBar animated variant="info" now={90} />
                    </div>
                    <div className="mb-2">
                      <span>
                        <strong>Node:</strong>
                      </span>
                      <ProgressBar animated variant="warning" now={60} />
                    </div>
                  </div>
                </Card.Text>
                <h6 className="text-muted">
                  <strong>Address : Narsingdi, Dhaka, Bangladesh</strong>
                </h6>
              </Card.Body>
            </Card>
          </div>
        </div>

        <div className="row g-lg-5">
          <h2 className="mb-3 text-center uppercase">My Projects</h2>

          <div className="col-md-4 col-12 ">
            <Card className="border-none">
              <Card.Img
                variant="top "
                className="object-cover img-fluid"
                src={project1}
              />
              <Card.Body>
                <Card.Title className=""> Hanu Studio - VFX STUDIO</Card.Title>
                <Card.Text>
                  Hanu Studios is to create incredible VFX and 3-D animation.We
                  care deeply about the quality of our services which is why we
                  commit only if we are sure about our ability to deliver the
                  best.
                </Card.Text>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.hanustudios.com/"
                >
                  {" "}
                  <button className=" btn btn-outline-dark">
                    {" "}
                    Live Perview{" "}
                  </button>{" "}
                </a>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 col-12 ">
            <Card className="border-none">
              <Card.Img
                variant="top"
                className="object-cover img-fluid"
                src={project2}
              />
              <Card.Body>
                <Card.Title className=" ">
                  {" "}
                  Mordano Ferniture e-Commerce
                </Card.Title>

                <Card.Text>
                  {" "}
                  Worldwide transport is available use by the general public,
                  distinct from modes such as taxicab, carpooling, or hired
                  buses.Logistics management involves identifying prospective
                  distributors.
                </Card.Text>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://analyzme-furniture.web.app/"
                >
                  {" "}
                  <button className="btn btn-outline-dark">
                    {" "}
                    Live Perview{" "}
                  </button>{" "}
                </a>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4 col-12 ">
            <Card className="border-none">
              <Card.Img
                variant="top"
                className="object-cover img-fluid"
                src={project3}
              />
              <Card.Body>
                <Card.Title className=" "> Photoghraper Protfolio</Card.Title>
                <Card.Text>
                  We study industries, competitors and consumers. We collect and
                  analyze data to make reasoned decisions.you can see great
                  breakthroughs and tips to learn and grow as a person.".
                </Card.Text>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://massio-2d3d0.web.app/"
                >
                  {" "}
                  <button className=" btn btn-outline-dark">
                    {" "}
                    Live Perview{" "}
                  </button>{" "}
                </a>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
